define('services/architect/flowService',[
    'lib/lodash4',
    'services/apiCore',
    'enums/architect/FlowType'
], function (
    _,
    apiCore,
    FlowType
) {
    'use strict';
    return {
        get: {
            page: function (data) {
                var endpoint = "/flows";
                data = data || {};
                data = _.assign({
                    type: FlowType.INBOUNDCALL,
                    pageSize: 25,
                    pageNumber: 1,
                    filter: ""
                }, data);

                return apiCore.v2.get(endpoint, data);
            }
        },
        getBrief: {
            page: function (data) {
                var endpoint = "/flows/divisionViews";
                data = data || {};
                data = _.assign({
                    type: FlowType.INBOUNDCALL,
                    pageSize: 25,
                    pageNumber: 1,
                    filter: ""
                }, data);

                return apiCore.v2.get(endpoint, data);
            }
        }
    };
});

